import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
export var GroupContext = /*#__PURE__*/React.createContext({
  isFromGroup: false
});
export function componentGenerator(Comp) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className,
        style = props.style,
        header = props.header,
        footer = props.footer,
        _props$bordered = props.bordered,
        bordered = _props$bordered === void 0 ? true : _props$bordered,
        options = props.options,
        children = props.children,
        onClick = props.onClick;
    var domRef = useRef(null);
    useImperativeHandle(ref, function () {
      return {
        dom: domRef.current
      };
    });

    function handleClick(e) {
      onClick && onClick(e);
    }

    return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
      var prefixCls = _ref.prefixCls;
      return /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-cell-group", 'all-border-box', className),
        ref: domRef,
        onClick: handleClick,
        style: style
      }, header ? /*#__PURE__*/React.createElement("div", {
        className: "cell-group-header"
      }, header) : null, /*#__PURE__*/React.createElement("div", {
        className: cls('cell-group-body', {
          bordered: bordered
        })
      }, /*#__PURE__*/React.createElement(GroupContext.Provider, {
        value: {
          isFromGroup: true
        }
      }, children, options && options.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Comp, _extends({
          key: index
        }, option));
      }))), footer ? /*#__PURE__*/React.createElement("div", {
        className: "cell-group-footer"
      }, footer) : null);
    });
  });
}